import { useEffect, useState } from 'react';

import type {
	ContentStatus as BoardStatus,
	MainActions,
	Collaborators,
	MoreActions,
} from '@confluence/content-types-header';
import {
	contentMainActionsService,
	contentCollaboratorsService,
	contentBoardStatusService,
	contentMoreActionsService,
} from '@confluence/content-types-bridge';

export const useDatabaseHeaderActions = () => {
	const [mainActions, setMainActions] = useState<MainActions | null>(null);
	const [collaborators, setCollaborators] = useState<Collaborators>({
		collaborators: [],
		me: null,
	});
	const [boardStatus, setBoardStatus] = useState<BoardStatus | null>(null);
	const [moreActions, setMoreActions] = useState<MoreActions | null>(null);

	useEffect(() => {
		contentMainActionsService.onActionsUpdate((mainAction) => {
			setMainActions(mainAction);
		});

		contentCollaboratorsService.onActionsUpdate((collaborator) => {
			setCollaborators(collaborator);
		});

		contentBoardStatusService.onActionsUpdate((status) => {
			setBoardStatus(status);
		});

		contentMoreActionsService.onActionsUpdate((moreAction) => {
			setMoreActions(moreAction);
		});
	}, [setMainActions, setCollaborators, setBoardStatus, setMoreActions]);

	return {
		mainActions,
		collaborators,
		contentStatus: boardStatus,
		moreActions,
	};
};
